import s from './MineTop.module.sass';
import React, { FC, useEffect } from 'react';
import { Button, Header, InlineHeader, Placeholder, ScrollView } from '$uikit';
import { useDispatch, useSelector } from 'react-redux';
import { useCurrentUserInfo, useTranslator, useUserInfo } from '$hooks';
import { CoinSquad } from '$store/models';
import { mineActions, selectMine } from '$store/mine';
import { Loader, MineOnboarding, UnitName } from '$shared/components';
import { IcAngleRight16, IcPlusCircle28 } from '$assets';
import { showModal } from '$navigation/helper';
import { useRouter } from 'react-router5';
import { MINE, MINE_SQUAD } from '$shared/constants/pages';
import { formatBigNumber } from '$utils';

export const MineTopSquad: FC<{ squad: CoinSquad; number: number }> = ({
  squad,
  number,
}) => {
  const user = useUserInfo(squad.userId);
  const router = useRouter();

  return (
    <div
      className={s.squad}
      onClick={() => router.navigate(MINE_SQUAD, { id: squad.id })}
    >
      <div className={s.squadNumber}>{number}</div>
      <div className={s.squadPhoto} style={{ backgroundImage: `url(${squad.url})` }} />
      <div className={s.squadCont}>
        <div className={s.squadName}>
          <UnitName unit={user} />
        </div>
        <div className={s.squadMembers}>
          {formatBigNumber(squad.earnAmount)} coins earned
        </div>
      </div>
      <div className={s.squadChevron}>
        <IcAngleRight16 />
      </div>
    </div>
  );
};

export const MineTop: FC = () => {
  const dispatch = useDispatch();
  const curUser = useCurrentUserInfo();
  const t = useTranslator();
  const router = useRouter();
  const {
    topLoadingStatus: loadingStatus,
    topItems,
    topTotalCount,
    onboardingPassed,
  } = useSelector(selectMine);

  const loadData = () => {
    dispatch(mineActions.loadTop());
  };

  useEffect(() => {
    loadData();
  }, []);

  function renderContent() {
    if (loadingStatus === 'failed') {
      return (
        <Placeholder
          title={t('failed_title')}
          actions={<Button onClick={loadData}>{t('failed_button')}</Button>}
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    if (loadingStatus === 'loading' && topItems.length === 0) {
      return <Loader isWrapped />;
    }

    return (
      <>
        <InlineHeader counter={`${topTotalCount}`}>Squads</InlineHeader>
        {topItems.map((item, i) => (
          <MineTopSquad key={item.id} squad={item} number={i + 1} />
        ))}
        <div className={s.limitInfo}>Displayed the first 300 squads</div>
      </>
    );
  }

  // if (!onboardingPassed && loadingStatus === '') {
  //   return (
  //     <>
  //       <Header showBackButton />
  //       <MineOnboarding />
  //     </>
  //   );
  // }

  return (
    <>
      <Header
        showBackButton
        rightIcons={[
          curUser?.verified === 2
            ? {
                icon: <IcPlusCircle28 />,
                onClick: () => showModal('mine_squad_new'),
              }
            : null,
        ]}
      >
        Top
      </Header>
      <ScrollView
        footer={
          <Button
            onClick={() => router.navigate(MINE, {}, { replace: true })}
            mode="light"
          >
            Go to game
          </Button>
        }
      >
        {renderContent()}
      </ScrollView>
    </>
  );
};
